<div class="wrapper">
  <div class="menu">
    <app-menu></app-menu>
  </div>
  <main>
    <app-toolbar class="header"></app-toolbar>
    <section class="content" [class.content--full-bleed]="fullBleed">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
